module.exports = __webpack_public_path__ + "static/media/highlighted_yellow.5bce7682.svg";